import React from 'react'
import { Box } from '@mui/material'
import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid'
import GridFilterHeader from './GridFilterHeader'

const styles = {
    grid: {
        backgroundColor: 'white',
        width: '100%',
        fontSize: '1rem',
        height: '100%',
        '& .MuiDataGrid-overlayWrapper': { minHeight: 100 },
    },
    toolbar: { minHeight: 52, px: 1, py: 0.5, gap: 1, borderBottom: 1, borderColor: 'divider' },
    left: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, flex: '1 1 200px', minWidth: 0 },
    right: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, ml: 'auto' },
}

function AppGridToolbar({ left, right, ...props }) {
    return (
        <GridToolbarContainer role='toolbar' aria-label='Table actions' {...props}>
            <Box role='group' aria-label='Table selection actions' sx={styles.left}>{left}</Box>
            <Box role='group' aria-label='Table primary actions' sx={styles.right}>{right}</Box>
        </GridToolbarContainer>
    )
}

export default function AppDataGrid({
    showToolbar = false,
    toolbarLeft,
    toolbarRight,
    checkboxSelection = false,
    headerFilters,
    columns,
    slots = {},
    slotProps = {},
    sx,
    ...props
}) {
    return (
        <DataGrid
            {...props}
            columns={headerFilters ? columns.map((column) => column.filterable === false || column.type === 'actions' ? column : {
                ...column,
                renderHeader: () => (
                    <GridFilterHeader
                        title={column.headerName || column.field}
                        field={column.field}
                        filterValue={headerFilters.values[column.field]}
                        onFilter={headerFilters.onChange}
                        disabled={headerFilters.disabled}
                        type={column.type === 'number' ? 'number' : column.type === 'dateTime' ? 'datetime-local' : 'text'}
                    />
                ),
            }) : columns}
            columnHeaderHeight={props.columnHeaderHeight ?? (headerFilters ? 80 : 56)}
            checkboxSelection={checkboxSelection}
            sx={[styles.grid, ...(props.autoHeight ? [{ height: 'auto' }] : []), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
            slots={{ ...slots, toolbar: showToolbar ? slots.toolbar || AppGridToolbar : undefined }}
            slotProps={{
                ...slotProps,
                toolbar: {
                    left: toolbarLeft,
                    right: toolbarRight,
                    ...slotProps.toolbar,
                    sx: [styles.toolbar, ...(Array.isArray(slotProps.toolbar?.sx) ? slotProps.toolbar.sx : slotProps.toolbar?.sx ? [slotProps.toolbar.sx] : [])],
                },
            }}
        />
    )
}
